module.exports = __webpack_public_path__ + "static/img/M.1f1c116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/M.png
// module id = JAFY
// module chunks = 0